export type CalculatedNearbyCondosParams = {
  minPriceSqft: number;
  maxPriceSqft: number;
  minArea: number;
  maxArea: number;
  unused?: boolean;
};

export const getNearbyCondosParamsUnit = ({
  minAvgCoef,
  maxAvgCoef,
  sqft,
  priceSqft,
}: {
  minAvgCoef: number;
  maxAvgCoef: number;
  sqft: number;
  priceSqft: number;
}): CalculatedNearbyCondosParams => {
  const minPriceSqft = Math.floor(priceSqft * minAvgCoef) || 0;
  const maxPriceSqft = Math.ceil(priceSqft * maxAvgCoef) || 100000000000;
  const minArea = Math.floor(sqft * minAvgCoef) || 0;
  const maxArea = Math.ceil(sqft * maxAvgCoef) || 100000000000;

  return { maxArea, maxPriceSqft, minArea, minPriceSqft };
};
